import { createApp } from 'vue/dist/vue.esm-bundler.js'
{
  const appConfig = {
    data(){
      return {
        loading: true,
        search: '',
        animalFilters: [],
        selectedAnimalFilters: [],
        events: [],
        currentlyViewingDate: new Date()
      }
    },
    mounted(){
      this.submitForm()
      document.addEventListener('click', e => {
        if(e.target.closest('.cool-calendar--cell') && e.target.tagName == "A"){
          e.preventDefault()
          const url = new URL(e.target.href)
          const dateStr = url.searchParams.get('date')
          if(dateStr) {
            const [year, month, day] = dateStr.split('-').map(Number)
            this.currentlyViewingDate = new Date(year, month - 1, day)
            this.selectedAnimalFilters = []
            this.submitForm(true)
          }
        }
      })

      // handle calendar button persistent open/close state between page loads
      const calendarButton = document.querySelector('#calendar-toggler')
      if (calendarButton) {
        if (!localStorage.getItem('cseCalendarTogglerState') || localStorage.getItem('cseCalendarTogglerState') === 'open') {
          calendarButton._onTogglerClick(false, 1)
        }

        calendarButton.addEventListener('click', () => {
          const isOpen = localStorage.getItem('cseCalendarTogglerState')
          localStorage.setItem('cseCalendarTogglerState', isOpen === 'open' ? 'closed' : 'open')
        })
      } 
    },
    computed: {
      announcement() {
        if(this.loading){
          return "Loading"
        } else {
          return `${this.events.length} results found.`
        }
      },
      currentlyViewingDateStr(){ 
        return this.currentlyViewingDate.toLocaleDateString('en-US', {
          month: 'long', day: 'numeric', year: 'numeric'
        })
      }
    },
    methods: {
      submitForm(focus) {
        this.loading = true
        window.coolHelperFunctions.coolAjax({
          action: 'fetch_daily_events_listing',
          currentlyViewingDate: this.currentlyViewingDateStr,
          search: this.search,
          animalFilters: this.selectedAnimalFilters
        }, success => {
          this.loading = false
          this.events = success?.data?.events || []
          this.animalFilters = success?.data?.availableAnimalFilters || []
          if(focus){
            this.$nextTick(() => {
              this.$refs.focusAnnouncement?.focus()
            })
          }
        }, error => {
          this.loading = false
          alert("Something went wrong. Please try again later.")
        })
      },

      submitAndFocus() {
        this.submitForm(true)
      },

      goToPrevDayAndFocus() {
        const d = new Date(this.currentlyViewingDate)
        d.setDate(d.getDate() - 1)
        this.currentlyViewingDate = d
        this.selectedAnimalFilters = []
        this.submitForm(true)
      },

      goToTodayAndFocus() {
        this.currentlyViewingDate = new Date()
        this.selectedAnimalFilters = []
        this.submitForm(true)
      },

      goToNextDayAndFocus() {
        const d = new Date(this.currentlyViewingDate)
        d.setDate(d.getDate() + 1)
        this.currentlyViewingDate = d
        this.selectedAnimalFilters = []
        this.submitForm(true)
      },
    }
  }

  function initApp(){
    const els = document.querySelectorAll('.daily-events-listing-app')
    if(els.length){
      els.forEach(el => {
        const app = createApp(appConfig)
        app.mount(el)
      })
    }
  }

  initApp()
}